
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import DefaultCreateForm from './DefaultCreateForm';

const { PRIVATE_ROUTE } = API_ROUTES;

function DefaultForm() {
  const { id } = useParams();
  const { authAxios } = useContext(FetchContext);
  const navigate = useNavigate();
  const location = useLocation();

  const defaultRecord = location.state?.defaultRecord || null;

  const [recordId, setRecordId] = useState(
    defaultRecord?.sourceId || defaultRecord?._id || id || ''
  );
  const [openModal] = useState(true);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      type: 'Invoice Item',
      Name: '',
    },
  });

  const handleClose = () => {
    if (location.state?.backgroundLocation) {
      navigate(-1);
    } else {
      navigate('/master/Invoice_Defaults/list');
    }
  };

  const loadFormData = useCallback(async () => {
    try {
      let record = defaultRecord;

      if (!record) {
        const response = await authAxios.get(
          `${PRIVATE_ROUTE.GET_INVOICE_DEFAULTS_BY_ID}${id}`
        );
        record = response.data?.data;
      }

      if (!record) {
        toast.error('Invoice Item or Tax Code record not found');
        return;
      }

      const type =
        record.type === 'Tax Code' ||
          record.type === 'taxcode' ||
          record.type === 'salestax'
          ? 'taxcode'
          : 'invoice items';

      const sourceId = record.sourceId || record._id || id;

      setRecordId(sourceId);

      reset({
        type,
        Name: record.Name ?? record.name ?? record.value ?? record.Value ?? '',
      });
    } catch (error) {
      console.error('Failed to load record:', {
        message: error.message,
        status: error.response?.status,
        response: error.response?.data,
      });

      toast.error(
        error.response?.data?.message || 'Failed to load Invoice Default'
      );
    }
  }, [authAxios, id, defaultRecord, reset]);

  useEffect(() => {
    loadFormData();
  }, [loadFormData]);

  const onSubmit = async (formData) => {
    try {
      const name = String(formData.Name || '').trim();

      if (!name) {
        toast.error('Please enter a name');
        return;
      }

      if (!recordId) {
        toast.error('Record _id is missing');
        return;
      }

      const payload = {
        type: formData.type, // "invoice items" or "taxcode"
        Name: String(formData.Name || '').trim(),
        _id: recordId,
      };

      const response = await authAxios.post(
        `${PRIVATE_ROUTE.EDIT_INVOICE_DEFAULTS}${id}`,
        payload
      );

      if (response.data?.success) {
        toast.success(
          response.data?.message || 'Record updated successfully'
        );

        navigate('/master/Invoice_Defaults/list', {
          replace: true,
          state: { refresh: Date.now() },
        });
      } else {
        toast.error(response.data?.message || 'Failed to update record');
      }

    } catch (error) {
      console.error('Failed to update record:', {
        message: error.message,
        status: error.response?.status,
        response: error.response?.data,
      });

      toast.error(
        error.response?.data?.message || 'Failed to update record'
      );
    }
  };

  return (
    <DefaultCreateForm
      open={openModal}
      onClose={handleClose}
      register={register}
      errors={errors}
      handleSubmit={handleSubmit}
      watch={watch}
      setValue={setValue}
      onSubmit={onSubmit}
      loading={isSubmitting}
      recordId={recordId}
    />
  );
}

export default DefaultForm;
